import React from 'react'
import FormBoxName from './FormBoxName'
import { variableStyle } from '../../../utils/styles'
import FormBoxRemark from './FormBoxRemark'
import DefaultValueBox from './DefaultValueBox'
import TriggerArray from './TriggerArray'
import HideInFormSwitcher from '../../common/HideInFormSwitcher'
import FormImagePredefinedValues from './FormImagePredefinedValues'
import { OptionalBoxCheckbox } from './OptionalVariableCheckbox'

const LeftPart = ({ box, onBlur, form }) => {
  return (
    <div className='variable-editor__middle' style={variableStyle["middle"]}>
      <div style={{ marginBottom: 16, fontWeight: "bold" }}>
        <HideInFormSwitcher boxId={box.id} variant='panel' />
      </div>
      <FormBoxName box={box} onBlur={onBlur} form={form} />
      <FormBoxRemark box={box} onBlur={onBlur} form={form} />
      <OptionalBoxCheckbox box={box} />
      <FormImagePredefinedValues box={box} />
    </div>
  )
}

const RightPart = ({ box, variablesGroupedByContainer }) => {
  return (
    <div className='variable-editor__middle' style={variableStyle["middle"]}>
      <DefaultValueBox box={box} />
      <TriggerArray box={box} variablesGroupedByContainer={variablesGroupedByContainer} />

    </div>
  )
}

const FormImage = ({ box, onBlur, form, formPart, variablesGroupedByContainer }) => {
  return (
    <>
      {formPart === 'left' && <LeftPart box={box} onBlur={onBlur} form={form} />}
      {formPart === 'right' && <RightPart box={box} variablesGroupedByContainer={variablesGroupedByContainer} />}
    </>
  )
}

export default FormImage
